<template>
  <div class="text-title font-bold mb-5">Booking failed</div>
  <div class="content-text">
    <p class="">
      We’re sorry, but your payment for {{ event.name }} at {{ show.city }} on
      {{
        show.start
          ? dateTimeFormat(show.start.toDate(), "dddd D MMMM YYYY H:mm")
          : "-"
      }}
      was not successful.
    </p>

    <p class="mt-5">
      We regret to inform you that the payment process for your booking was
      interrupted, leading to the cancellation of your reservation.
      Consequently, the tickets you had previously reserved have been released.
    </p>
    <p class="mt-5">
      To secure your desired tickets once again, we kindly request that you
      initiate the booking process anew. Should you have any questions or
      encounter any difficulties, please do not hesitate to reach out to us at
      <strong> support@n3.app.</strong>
    </p>
  </div>

  <div class="text-center mt-10">
    <default-button
      class="w-full sm:w-2/6"
      @click="
        $router.push({
          name: show.tickets ? 'standingSelection' : 'seatSelection',
        })
      "
      label="Secure your tickets"
    />
  </div>
</template>
<script>
import { dateTimeFormat } from "@/utils/helper";
import { computed, reactive, toRefs } from "vue";
import { useStore } from "vuex";
import DefaultButton from "@/components/button/DefaultButton.vue";
import { useMeta } from "vue-meta";
export default {
  components: { DefaultButton },
  name: "PaymentFailed",
  setup() {
    useMeta({
      title: "Payment Failed",
    });
    const store = useStore();
    const state = reactive({
      event: computed(() => store.state.event.event),
      show: computed(() => store.state.show.show),
    });

    return {
      ...toRefs(state),
      dateTimeFormat,
    };
  },
};
</script>
